<template>
  <div id="featured">
    <div class="row">
      <div class="col-6 my-auto">
        <p class="mb-0">Featured Albums</p>
      </div>
      <div class="col-6 my-auto">
        <FilterBar :list="'featured'"></FilterBar>
      </div>
    </div>
    <vuetable ref="vuetable"
              data-path="featuredAlbums"
              pagination-path="pagination"
              track-by="featured_id"
              :api-url="apiUrl"
              :fields="fields"
              :http-options="httpOptions"
              :css="css.table"
              :per-page="10"
              :append-params="moreParams"
              :query-params="{
                sort: 'sort',
                page: 'page',
                perPage: 'perPage'}"
              @vuetable:pagination-data="onPaginationData">
      <template slot="images" slot-scope="props">
        <img :src="props.rowData.thumbnail"
             alt="album-thumbnail"
             width="60"
             height="60" />
      </template>
      <template slot="action-item" slot-scope="props">
        <button class="btn btn-sm btn-outline-danger"
                type="button"
                @click="removeFeatured(props.rowData)">
          <i class="far fa-trash-alt"></i> Remove
        </button>
      </template>
    </vuetable>

    <!-- Pagination -->
    <div class="d-flex align-items-center justify-content-end">
      <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
      <vuetable-pagination ref="pagination"
                           @vuetable-pagination:change-page="onChangePage"
                           :css="css.pagination">
      </vuetable-pagination>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import TableStyle from '../table-bootstrap-css.js';

  const FilterBar =
    () => import('@/components/admin/featured_album/FilterBar.vue');
  const Vuetable = () => import('vuetable-2/src/components/Vuetable');
  const VuetablePagination = () =>
  import('vuetable-2/src/components/VuetablePagination');
  const VuetablePaginationInfo = () =>
  import('vuetable-2/src/components/VuetablePaginationInfo');

  export default {
    name  : 'FeaturedAlbumList',
    props : {
      update : Boolean,
    },
    data() {
      return {
        apiUrl      : process.env.VUE_APP_ROOT_API + 'api/albums/featuredAdmin',
        moreParams  : {},
        css         : TableStyle,
        httpOptions : {
          headers : {
            'Authorization' : `Bearer ${this.$store.state.auth.accessToken}`,
          },
        },
        fields : [ {
          name       : 'featured_id',
          title      : 'Featured<br>ID',
          sortField  : 'featured_id',
          direction  : 'desc',
          titleClass : 'text-center',
          dataClass  : 'text-center',
        }, {
          name       : '__slot:images',
          title      : 'Thumbnail',
          titleClass : 'text-center',
          dataClass  : 'text-center',
        }, {
          name      : 'album_name',
          title     : 'Album Name',
          sortField : 'album_name',
          direction : 'desc',
        }, {
          name       : 'no_of_tracks',
          title      : 'No of tracks',
          sortField  : 'no_of_tracks',
          direction  : 'desc',
          titleClass : 'text-center',
          dataClass  : 'text-center',
        }, {
          name       : '__slot:action-item',
          title      : 'Action',
          titleClass : 'text-center',
          dataClass  : 'text-center',
        } ],
      }
    },
    components : {
      FilterBar,
      Vuetable,
      VuetablePagination,
      VuetablePaginationInfo,
    },
    watch : {
      update(value) {
        if (value) {
          this.$refs.vuetable.refresh();
          this.$emit('update-featured-table');
        }
      },
    },
    methods : {

      transform(data) {
        const transformed = {};

        if (data.result.data.length === 0 && data.result.currentPage > 1) {
          // redirect to previous page
          this.onChangePage(data.result.currentPage - 1);
        } else {
          transformed.pagination = {
            total         : data.result.total,
            per_page      : data.result.perPage,
            current_page  : data.result.currentPage,
            last_page     : data.result.lastPage,
            next_page_url : data.result.nextPageUrl,
            prev_page_url : data.result.prevPageUrl,
            from          : data.result.from,
            to            : data.result.to,
          };

          transformed.featuredAlbums = [];

          for (let i = 0; i < data.result.data.length; i++) {
            transformed.featuredAlbums.push({
              featured_id     : data.result.data[i].featured_id,
              album_name      : data.result.data[i].album_name,
              mobile_album_id : data.result.data[i].mobile_album_id,
              thumbnail       : data.result.data[i].album_thumbnail,
              no_of_tracks    : data.result.data[i].no_of_tracks,
            });
          }
        }

        return transformed;
      },

      /**
       * Remove Featured Album
       * @param data
       */
      removeFeatured(data) {
        this.$modal.show('dialog', {
          title : 'Remove Featured Album',
          text  : 'Are you sure you want to remove <b>' + data.album_name +
            '</b>?',
          buttons : [ {
            title   : 'Yes',
            handler : () => {
              this.$http.delete('api/albums/featured', {
                data : {
                  albumId : data.mobile_album_id,
                },
              }).then(() => {
                this.$notify({
                  group : 'notif',
                  type  : 'success',
                  title : 'Success!',
                  text  : 'Deleted ' + data.album_name + ' from Featured List!',
                });
                this.$modal.hide('dialog');
                this.reloadTable();
              })
            },
          }, {
            title : 'No',
          } ],
        })
      },

      /**
       * Reload Table
       */
      reloadTable() {
        this.$refs.vuetable.reload(); // reload vuetable
        this.$emit('update-album-table');
      },

      /**
       * Set Pagination Info
       * @param paginationData
       */
      onPaginationData(paginationData) {
        this.$refs.pagination.setPaginationData(paginationData);
        this.$refs.paginationInfo.setPaginationData(paginationData);
      },

      /**
       * Change page
       * @param page
       */
      onChangePage(page) {
        this.$refs.vuetable.changePage(page);
      },

      /**
       * On Filter Set
       * @param filterText
       */
      onFilterSet(filterText) {
        this.moreParams = {
          'filter' : filterText,
        };
        Vue.nextTick(() => this.$refs.vuetable.refresh());
      },

      /**
       * On Filter Reset
       */
      onFilterReset() {
        this.moreParams = {};
        Vue.nextTick(() => this.$refs.vuetable.refresh());
      },
    },
    mounted() {
      this.$events.$on('filter-set-featured', eventData =>
        this.onFilterSet(eventData));
      this.$events.$on('filter-reset-featured', () => this.onFilterReset());
    },
  }
</script>

<style lang="scss" scoped>
  @import
    "../../../assets/scss/components/admin/featured_album/featured-album-list";
</style>